import axios from "axios";
import { FETCH_LANDING_PAGE_COUNT } from "../actions/types";

export const fetchLandingPageCount = async (currentYear, dispatch) => {
  await axios
    .get("api/v1/hwts/search/yearlycounts", {
      params: {
        ShipYear: currentYear,
      },
    })
    .then((results) => {
      dispatch({
        type: FETCH_LANDING_PAGE_COUNT,
        payload: results.data,
        isFetching: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_LANDING_PAGE_COUNT,
        isFetching: false,
        payload: {
          epaIdCount: 0,
          manifestCount: 0,
          tonnageCount: 0,
        },
      });
    });
};
